'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Base,
    WebRTCRuntime,
    debug,
    boundMethodCheck = function boundMethodCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new Error('Bound instance method accessed before binding');
  }
};

Base = require('./base');

debug = require('debug')('fbp-protocol-client:webrtc');

WebRTCRuntime = function (_Base) {
  _inherits(WebRTCRuntime, _Base);

  function WebRTCRuntime(definition) {
    _classCallCheck(this, WebRTCRuntime);

    var _this = _possibleConstructorReturn(this, (WebRTCRuntime.__proto__ || Object.getPrototypeOf(WebRTCRuntime)).call(this, definition));

    _this.handleError = _this.handleError.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);
    _this.peer = null;
    _this.connecting = false;
    _this.connection = null;
    _this.protocol = 'webrtc';
    _this.buffer = [];
    return _this;
  }

  _createClass(WebRTCRuntime, [{
    key: 'getElement',
    value: function getElement() {
      return null;
    }
  }, {
    key: 'isConnected',
    value: function isConnected() {
      return this.connection !== null;
    }
  }, {
    key: 'connect',
    value: function connect() {
      var _this2 = this;

      var address, id, options, signaller;
      if (this.connection || this.connecting) {
        return;
      }
      address = this.getAddress();
      if (address.indexOf('#') !== -1) {
        signaller = address.split('#')[0];
        id = address.split('#')[1];
      } else {
        signaller = 'https://api.flowhub.io';
        id = address;
      }
      options = {
        room: id,
        debug: true,
        channels: {
          chat: true
        },
        signaller: signaller,
        capture: false,
        constraints: false,
        expectedLocalStreams: 0
      };
      this.peer = RTC(options);
      this.peer.on('channel:opened:chat', function (id, dc) {
        _this2.connection = dc;
        _this2.connection.onmessage = function (data) {
          debug('message', data.data);
          return _this2.handleMessage(data.data);
        };
        _this2.connecting = false;
        _this2.sendRuntime('getruntime', {});
        _this2.emit('status', {
          online: true,
          label: 'connected'
        });
        _this2.emit('connected');
        return _this2.flush();
      });
      this.peer.on('channel:closed:chat', function (id, dc) {
        dc.onmessage = null;
        _this2.connection = null;
        _this2.emit('status', {
          online: false,
          label: 'disconnected'
        });
        return _this2.emit('disconnected');
      });
      return this.connecting = true;
    }
  }, {
    key: 'disconnect',
    value: function disconnect() {
      if (!this.connection) {
        return;
      }
      this.connecting = false;
      this.connection.close();
      this.connection = null;
      return this.emit('disconnected');
    }
  }, {
    key: 'send',
    value: function send(protocol, command, payload) {
      var m;
      m = {
        protocol: protocol,
        command: command,
        payload: payload
      };
      if (this.connecting) {
        this.buffer.push(m);
        return;
      }
      if (!this.connection) {
        return;
      }
      debug('send', m);
      return this.connection.send(JSON.stringify(m));
    }
  }, {
    key: 'handleError',
    value: function handleError(error) {
      boundMethodCheck(this, WebRTCRuntime);
      this.connection = null;
      return this.connecting = false;
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage(message) {
      var msg;
      boundMethodCheck(this, WebRTCRuntime);
      msg = JSON.parse(message);
      return this.recvMessage(msg);
    }
  }, {
    key: 'flush',
    value: function flush() {
      var i, item, len, ref;
      ref = this.buffer;
      for (i = 0, len = ref.length; i < len; i++) {
        item = ref[i];
        this.send(item.protocol, item.command, item.payload);
      }
      return this.buffer = [];
    }
  }]);

  return WebRTCRuntime;
}(Base);

module.exports = WebRTCRuntime;